"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _eventQueue = _interopRequireDefault(require("./eventQueue"));
var _eventComposer = _interopRequireDefault(require("./eventComposer"));
var _captureClick = _interopRequireDefault(require("./captureClick"));
var _getters = _interopRequireDefault(require("./getters"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Analytics = exports["default"] = /*#__PURE__*/function () {
  function Analytics() {
    var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
    _classCallCheck(this, Analytics);
    // flush events on unload
    win.addEventListener('unload', function () {
      _eventQueue["default"].flush(true);
    });
    // listen for the click events
    (0, _captureClick["default"])(this, win);
  }
  return _createClass(Analytics, [{
    key: "report",
    value: function report(topic, body) {
      // todo: capture first action taken (if we refactor MyT to call this)
      _eventQueue["default"].add(_eventComposer["default"].compose(topic, body));
    }
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      return _getters["default"].sessionId;
    }
  }, {
    key: "setHeaderDefaults",
    value: function setHeaderDefaults(defaults) {
      _eventComposer["default"].extendHeaderDefaults(defaults);
    }
  }, {
    key: "setBodyDefaults",
    value: function setBodyDefaults(defaults) {
      _eventComposer["default"].extendBodyDefaults(defaults);
    }
  }, {
    key: "flush",
    value: function flush() {
      _eventQueue["default"].flush();
    }
  }]);
}();